<template>
  <div>
    <p class="title">费用结算</p>
    <orderReceipt/>
    <orderPayment/>
  </div>
</template>
<script>
import orderReceipt from './components/orderReceipt'
import orderPayment from './components/orderPayment'

export default {
  components: { orderReceipt, orderPayment },
}
</script>

<style lang="scss" scoped>
.title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: 600;
    font-size: 16px;
    color: #323233;
    margin-bottom: 14px;
  }
</style>
